import LocalStorage from "../localStorage";
import cryptoPresets from "../../assets/heatMapPresets/cryptoPresets.json";

const retrieveConfigs = () => {
  const localStorageConfigs = LocalStorage.getCustomHeatMapConfigurations();

  return cryptoPresets.concat(localStorageConfigs);
};

export default retrieveConfigs;
